import React from 'react';
import AiModel from '../../components/AiModel/AiModel';

const AiModelPage = () => {
    return (
        <AiModel />
    );
};

export default AiModelPage;